import { BunkerBargeOffData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import StringToNumberPropTransformer from "../StringToNumberPropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const BUNKER_BARGE_OFF_DATA_TAG = 'BunkerBargeOffData';
export default class BunkerBargeOffParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.BUNKERING_STATION_OFF, FIXED_PROTOCOL_CONTENT_TYPE_IDS.BUNKERING_STATION_OFF, BUNKER_BARGE_OFF_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            name: 'name',
            freeText: 'freeText',
            finishOp: 'finishOperation',
            quant: new StringToNumberPropTransformer('quantity'),
            unit: 'unit',
        };
    }
    createData(props, record) {
        const data = new BunkerBargeOffData(props.name || '', props.finishOperation, props.quantity, props.unit, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.name || '',
            };
            data.name = link;
        }
        return data;
    }
}
//# sourceMappingURL=BunkerBargeOffParser.js.map